import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../../store/slices/authSlice';

const PublicRoute = ({ children }) => {
  const user = useSelector(selectUser);

  if (user && user.role) {
    // Redirect sellers who haven't completed onboarding
    if (user.role === 'seller' && user.seller && user.seller.onboarding_status !== 'approved') {
      return <Navigate to="/seller/onboarding/status" replace />;
    }

    // Redirect authenticated users away from public auth pages
    const redirects = {
      customer: '/',
      seller: '/seller/dashboard',
      admin: '/admin/dashboard',
    };
    return <Navigate to={redirects[user.role] || '/'} replace />;
  }

  // If not authenticated, render the children (like Login or Register page)
  return children;
};

export default PublicRoute;
